import { render, staticRenderFns } from "./SocialListGrouped.vue?vue&type=template&id=6d2984d1&scoped=true"
import script from "./SocialListGrouped.vue?vue&type=script&lang=js"
export * from "./SocialListGrouped.vue?vue&type=script&lang=js"
import style0 from "./SocialListGrouped.vue?vue&type=style&index=0&id=6d2984d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2984d1",
  null
  
)

export default component.exports